import { QueryVehiclePDPConfigurator, SchemaTypes } from '@allesauto/graphql';
import { getCarConfiguratorParamsRouterQuery } from '@allesauto/utils/funcs';
import { useLazyQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { ILazyDataResponse } from '@/global/models/IDataResponse';

import { getVehiclePDPData } from '../funcs';
import { CarConfiguratorVariables } from '../types';

export const useCarConfigurator = (): ILazyDataResponse<
  SchemaTypes.Vehicle | undefined,
  (
    configuratorParams: CarConfiguratorVariables
  ) => Promise<SchemaTypes.Vehicle | undefined | null>
> => {
  const [getConfiguratorVehicle, { loading, data, error }] = useLazyQuery<
    Pick<SchemaTypes.Query, 'vehicleById'>
  >(QueryVehiclePDPConfigurator);

  return {
    executeCall: async (configuratorParams) => {
      const { data } = await getConfiguratorVehicle({
        variables: {
          ...configuratorParams,
        },
      });
      return data?.vehicleById;
    },
    data: data?.vehicleById,
    loading: loading,
    error,
  };
};

export const useCarConfiguratorQueryParams = () => {
  const router = useRouter();

  const { configuratorId: carConfiguratorId, configuratorDealerId } = useMemo(
    () => getCarConfiguratorParamsRouterQuery(router.query),
    [router.query]
  );

  return {
    carConfiguratorId,
    configuratorDealerId,
  };
};

export const useVehiclePDPData = (
  vehicle: SchemaTypes.Vehicle,
  carConfigurator: SchemaTypes.Vehicle | undefined | null
): SchemaTypes.Vehicle => {
  return useMemo(
    () => getVehiclePDPData(vehicle, carConfigurator),
    [carConfigurator, vehicle]
  );
};
